import { useEffect } from "react"
import { getCurrentAndNextWord, getNewActive } from "./common"

const cpy = (matrix) => {
  return matrix.map((row) => row.slice())
}

const insertAtActive = (cells, active, val) => {
  let newCells = cpy(cells),
    cell = newCells[active.y][active.x]

  cell.value = val.toUpperCase()

  return newCells
}

const adjacentActive = (cells, active, iter) => {
  let nextPos =
    active.dir === "→"
      ? { x: iter(active.x), y: active.y }
      : { x: active.x, y: iter(active.y) }

  let m = cells[0].length,
    isYPosOk = 0 <= nextPos.y && nextPos.y < m,
    isXPosOk = 0 <= nextPos.x && nextPos.x < m,
    isNextPosDisabled = !(isYPosOk && isXPosOk)
      ? true
      : cells[nextPos.y][nextPos.x].disabled,
    newActive = !isNextPosDisabled ? { ...active, ...nextPos } : active

  return newActive
}

const nextActive = (cells, active) =>
  adjacentActive(cells, active, (a) => a + 1)
const prevActive = (cells, active) =>
  adjacentActive(cells, active, (a) => a - 1)

const pressKeyAtActive = (cells, active, key) => {
  const newCells = insertAtActive(cells, active, key.toUpperCase()),
    newActive = nextActive(cells, active)

  return [newCells, newActive]
}

const backspaceAtActive = (cells, active) => {
  const newCells = insertAtActive(cells, active, ""),
    newActive = prevActive(cells, active)

  return [newCells, newActive]
}

const nextAtActive = (cells, active, key, size) => {
  const { next: newActive } = getCurrentAndNextWord(cells, active)

  return [cells, getNewActive(newActive, active, size)]
}

export const useKeyboard = (
  cells,
  setCells,
  active,
  setActive,
  onKeyInserted,
  size,
  debugMode
) => {
  useEffect(() => {
    if (debugMode) return

    const handleKeyDown = (e) => {
      e.preventDefault()

      const isLetter = /^[a-zA-Z]$/.test(e.key),
        isBackspace = e.key === "Backspace",
        isTab = e.key === "Tab" && !debugMode

      const fn = isLetter
        ? pressKeyAtActive
        : isBackspace
        ? backspaceAtActive
        : isTab
        ? nextAtActive
        : null

      if (fn) {
        const [newCells, newActive] = fn(cells, active, e.key, size)
        setCells(newCells)
        setActive(newActive)
      }

      if (fn === pressKeyAtActive) onKeyInserted()
    }

    document.addEventListener("keydown", handleKeyDown)

    return () => {
      document.removeEventListener("keydown", handleKeyDown)
    }
  }, [cells, setCells, active, setActive, onKeyInserted, size, debugMode])
}
